import { render } from "./StatisticalPage.vue?vue&type=template&id=35b735f0&ts=true"
import script from "./StatisticalPage.vue?vue&type=script&lang=ts"
export * from "./StatisticalPage.vue?vue&type=script&lang=ts"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/QuanLy_Spa/QuanLy_Spa_FE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__